function optionSelectorLabel(element, label) {
  if (element.closest('.wtb-only')) return label;
  return `Choose ${label}`;
}

function setWhereToBuySku(root, variant) {
  if (!variant || !variant.sku) return;var changed = false;
  root.querySelectorAll('.where-to-buy').forEach((button) => {
    if (button.getAttribute('ps-sku') === variant.sku) return;
    button.setAttribute('ps-sku', variant.sku);button.classList.remove('ps-enabled');
    changed = true;
  });

  if (changed && window.PriceSpider && typeof window.PriceSpider.rebind === 'function') {
    window.PriceSpider.rebind();
  }
}

if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.isPdp = this.dataset.isPdp == 'true';
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options.filter(x=>(requiredOptionsSettingUnique.indexOf(x)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && this.getOptionValues(x).length>1);
      
      // Appending Media to filter galleries automatically
      if (this.productData.groupDetails && this.productData.groupDetails.appendMediaAlt) {
        if (this.productData.groupDetails.media) {
          this.productData.media = this.productData.media.map(media => {
            let appendMedia = this.productData.groupDetails.media[media.id]?.alt;
            return {
              ...media,
              alt: `${appendMedia ? `${appendMedia};` : ''}${media.alt?media.alt:''}`
            }
          })
        }
      }
      
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));

      this.observeForReviews();

      // Auto-select first available Size swatch on initial load (failsafe guarded)
      setTimeout(() => {
        if (!this.isConnected) return;

        const sizeSwatchGroup = this.querySelector('product-swatch[data-label="Size"]');
        const scope = sizeSwatchGroup || this;
        if (!scope) return;

        const swatchGroup = scope.querySelector(".swatch-group");
        if (!swatchGroup) return;

        const firstAvailableSwatch = swatchGroup.querySelector(".swatch[data-available='true']");

        const checkedInput = this.querySelector('.swatch input:checked');
              
        if (firstAvailableSwatch && checkedInput.hasAttribute("disabled")) {
          const input = firstAvailableSwatch.querySelector("input[type='radio']");
          if (input && !input.disabled) {
            input.click(); // Click the first available swatch
          }
        }


        
      }, 1000);
      this.isNotAvailable();
    }

    isNotAvailable() {
      if (this.classList.contains('not-available')){
        var notAvailableBtn = document.createElement('div');
        notAvailableBtn.classList.add('btn', 'one-whole');
        notAvailableBtn.innerHTML = this.dataset.notAvailableMessage;

        if(this.querySelector('.block-button') != null){
          this.querySelector('.block-button').insertAdjacentElement('afterbegin', notAvailableBtn);
          this.querySelector('.block-button .qtty-atc, .block-button .quantity-box').remove();
        }

        if(this.querySelector('.block-button .shopify-payment-button') != null){
          this.querySelector('.block-button .shopify-payment-button').remove();
        }

        if(this.querySelector('product-sticky-panel') != null) {
          
          this.querySelector('product-sticky-panel product-buttons .info').insertAdjacentElement('beforeend', notAvailableBtn.cloneNode(true));
          this.querySelector('product-sticky-panel product-buttons .btn').style.display = 'none';
        }
      }
    }

    observeForReviews() {
      const targetSection = document.querySelector("div[id*='bazaarvoice_reviews_photos_reviews_block']");

      if (targetSection) {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const section = entry.target.closest('.shopify-section');
              const nextSection = section.parentNode.querySelector('#' + section.id + ' ~ .shopify-section') || document.getElementById('footer');
              const ref = nextSection.getAttribute('id');
              targetSection.insertAdjacentHTML('beforebegin', `<div class="skip-reviews-wrapper" style="position: relative;"><div class="visually-hidden medium-down--hide">${lngg.skip_reviews_button}</div><a class="skip-to-content-link visually-hidden medium-down--hide" href="#${ref}" onclick="document.querySelector('#${ref}').focus()" style="left: 5%;">${lngg.skip_reviews_button}</a></div>`);            
              observer.unobserve(targetSection);
            }
          });
        });
  
        observer.observe(targetSection);
      }

    }

    getOptionValues(optionName) {
      if (!this.optionValues[optionName]) {
        function filterUnique(value, index, array) {
          return array.indexOf(value) === index;
        }
        var ix = this.productData.options.indexOf(optionName);
        this.optionValues[optionName] = this.productData.variants.map(v=>v['option'+(1+ix)]).filter(filterUnique);
      }
      return this.optionValues[optionName];
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options.length;   
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      console.log(this.sellingPlanElement)
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }

    async getProductByHandle(handle) {
      let cleanHandle = handle.split("?")[0];
      try {
        const response = await fetch(`${cleanHandle}.js`);
        if (!response.ok) throw new Error("Product not found");
        const product = await response.json();
        return product; // returns product
      } catch (error) {
        console.error(error);
        return null;
      }
    }

    
    onVariantChange(event) {
      //lightweight update of elements that not worth creating their own components
      if (!event || !event.detail || !event.detail.variant) return;
      var variant = event.detail.variant;

      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });

        // Update title for groupedProducts
        if (this.productData.groupDetails && this.productData.groupDetails.groups) {
          const groupData = this.productData.groupDetails.groups[variant.id];
          if (!groupData) {
            return;
          }

          let titleEl = this.querySelector('.title-wrap > h1') || this.querySelector('.block-title > h1');
          let titleEl2 = this.querySelector('.sticky-title');
          if (!titleEl) titleEl = this.querySelector('.title');
          if (!titleEl) {
            return;
          }
          if (!titleEl2) titleEl2 = this.querySelector('.title');
          if (!titleEl2) {
            return;
          }

          let decodedTitle = new DOMParser()
          .parseFromString(titleEl.innerHTML, "text/html")
          .documentElement.textContent;
        
          let decodedGroup = new DOMParser()
          .parseFromString(groupData.title, "text/html")
          .documentElement.textContent;

          if (decodedTitle != decodedGroup) {
            
            // Recipe changed – auto-select first available Size swatch after swatches update
            setTimeout(() => {
              if (!this.isConnected) return;

              const sizeSwatchGroup = this.querySelector('product-swatch[data-label="Size"]');
              const scope = sizeSwatchGroup || this;
              if (!scope) return;

              const swatchGroup = scope.querySelector(".swatch-group");
              if (!swatchGroup) return;
              const firstAvailableSwatch = swatchGroup.querySelector(".swatch[data-available='true']");
              const checkedInput = this.querySelector('.swatch input:checked');
              
              if (firstAvailableSwatch && checkedInput.hasAttribute("disabled")) {
                const input = firstAvailableSwatch.querySelector("input[type='radio']");
                if (input && !input.disabled) {
                  input.click(); // Click the first available swatch
                }
              }

            }, 1000);
          }
          
          titleEl.innerHTML = groupData.title;
          titleEl2.innerHTML = groupData.title;
          //
          let variantesArray = [];
          let unavailableVariantes = [];
          let hiddenVariants = [];
          
          this.getProductByHandle(groupData.url).then(prod => {
            if(this.closest('product-main')){
              if(document.querySelector("div[id*='bazaarvoice_reviews_photos_rating_summary_block']") != null){
                document.querySelector("div[id*='bazaarvoice_reviews_photos_rating_summary_block'] div[data-bv-product-id]").style.minHeight = document.querySelector("div[id*='bazaarvoice_reviews_photos_rating_summary_block'] div[data-bv-product-id]").offsetHeight + 'px';
                document.querySelector("div[id*='bazaarvoice_reviews_photos_rating_summary_block'] div[data-bv-product-id]").setAttribute('data-bv-product-id', prod.id);
              }
              if(document.querySelector("div[id*='bazaarvoice_reviews_photos_reviews_block']") != null){
                document.querySelector("div[id*='bazaarvoice_reviews_photos_reviews_block']").setAttribute('data-bv-product-id', prod.id);
                document.querySelector("div[id*='bazaarvoice_reviews_photos_reviews_block'] div[data-bv-product-id]").setAttribute('data-bv-product-id', prod.id);
              }
            }
            var variants = prod.variants;
            if (!variants || !Array.isArray(variants)) return;

            variants.forEach(variante => {
              if (!variantesArray.includes(variante.option1)) {
                variantesArray.push(variante.option1);
              }
              if(variante.available == false && !unavailableVariantes.includes(variante.option1)){
                unavailableVariantes.push(variante.option1);  
              }

              const featuredImage = variante.featured_image;
              const hidden = featuredImage ? (groupData?.hiddenOnes?.[featuredImage.product_id]) : null;
              if (hidden) {
                for (const variantId in hidden) {
                  if (hidden[variantId].value === "true") {
                    hiddenVariants.push(hidden[variantId].name);
                  }
                }

                const whereTo = featuredImage ? (groupData?.whereToBuy?.[featuredImage.product_id]) : null;
                let notAvailable = false;

                  if(whereTo[variant.id].not_available){
                    var requiredBtn = null;
                    var blurb = this.querySelector('.where-to-buy-blurb');
                    if (blurb) blurb.style.display = 'none';
            
                    notAvailable = whereTo[variant.id].not_available;
                  }

                  if (this.required() && requiredBtn && notAvailable == false) {
                    if (this.dynamicButtons) {
                      this.dynamicButtons.classList.add('hide');
                    }
                    requiredBtn.style.display = '';
                    requiredBtn.innerHTML = this.requiredMessage;
          
                  } else if (notAvailable) {
                    if (this.dynamicButtons) {
                      this.dynamicButtons.classList.add('hide');
                    }
          
                    // Hide normal ATC and all default sold-out / not-available messages
                    this.querySelector('.btn.add').style.display = 'none';
                    this.querySelector('.sold-out-message').style.display = 'none';
                    
          
                    // Let Where to Buy plugin handle this button
                    this.querySelector('.where-to-buy').classList.remove('disabled');
                    setWhereToBuySku(this, variant);
          
                    if (blurb) blurb.style.display = '';
                    if (requiredBtn) requiredBtn.style.display = 'none';
          
                  }
              }

            })

            this.querySelectorAll('.swatch').forEach(swatch => {
              let input = swatch.querySelector('input');
              if (!input) return;
              let value = (input.value || '').trim();
              
              if(unavailableVariantes.includes(value)){
                swatch.dataset.available = "false"
              }else{
                swatch.dataset.available = "true"
              }
            
              if(!variantesArray.includes(value) || hiddenVariants.includes(value)){
                swatch.style.display ='none';
                input.disabled = true;             // disable input
                swatch.classList.add('disabled');  // optional: add a visual cue
                swatch.dataset.available = "false";
              }else{
                swatch.style.display ='block';
                swatch.dataset.available = true;
                input.disabled = false;            // ensure it's enabled if valid
                swatch.classList.remove('disabled');
              }
            });
            
            this.getProductByHandle(groupData.url).then(prod => {
              var variants = prod.variants;
              if (!variants) return;
  
              variants.forEach(variante => {
                if (!variante.available) {
                  const input = this.querySelector(
                    `input[value="${variante.options[0]}"]`
                  );
              
                  input.dataset.available = false;
                  input.parentNode.dataset.available = false;
                }
              });
            });
          });
        }}
  }
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
      }

      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      if (this.classList.contains('not-available')){
        var notAvailableBtn = document.createElement('div');
        notAvailableBtn.classList.add('btn', 'smaller');
        notAvailableBtn.innerHTML = this.dataset.notAvailableMessage;
        this.querySelector('add-to-cart-form').insertAdjacentElement('afterend', notAvailableBtn);

        this.querySelector('add-to-cart-form').remove();
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    openOptions(e) {
      e.preventDefault()
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    async getProductByHandleWoVariants(handle) {
      let cleanHandle = handle.split("?")[0];
      try {
        const response = await fetch(`${cleanHandle}.js`);
        if (!response.ok) throw new Error("Product not found");
        const product = await response.json();
        return product; // returns array of variants
      } catch (error) {
        console.error(error);
        return null;
      }
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media ? variant.featured_image : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      //
   
      //update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }

      let groupDataUrl = this.productData.groupDetails.groups[variant.id].url;
      if (this.quickViewBtn) {
        this.quickViewBtn.dataset.url = groupDataUrl;
      }
      this.getProductByHandle(groupDataUrl).then(prod => {
        this.closest('.product-card').querySelector('.review-stars').style.minHeight = this.closest('.product-card').querySelector('.review-stars').offsetHeight + 'px';
        this.closest('.product-card').querySelector('.review-stars').setAttribute('data-bv-product-id', prod.id);
      });

    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.mainElement.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e) => {
        var requiredBtn = null;
        var blurb = this.querySelector('.where-to-buy-blurb');
        if (blurb) blurb.style.display = 'none';

        let notAvailable = false;
        if (e.detail.variant && this.mainElement.productData && this.mainElement.productData.variants_metafields) {
          const vm = this.mainElement.productData.variants_metafields.find(x => x.variant_id == e.detail.variant.id);
          if (vm && vm.metafields) {
            const v = vm.metafields['not_available'];
            notAvailable = (v === true || v === 'true');
          }
        }

        if (this.required() && requiredBtn && notAvailable == false) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;

        } else if (notAvailable) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }

          // Hide normal ATC and all default sold-out / not-available messages
          this.querySelector('.btn.add').style.display = 'none';
          this.querySelector('.sold-out-message').style.display = 'none';
          

          // Let Where to Buy plugin handle this button
          this.querySelector('.where-to-buy').classList.remove('disabled');
          setWhereToBuySku(this, e.detail.variant);

          if (blurb) blurb.style.display = '';
          if (requiredBtn) requiredBtn.style.display = 'none';

        } else if (e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add').style.display = '';
          this.querySelector('.sold-out-message').style.display = 'none';
          
          this.querySelector('.where-to-buy').classList.add('disabled');
          if (requiredBtn) requiredBtn.style.display = 'none';

        } else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          //this.querySelector('.sold-out-message').style.display = '';
          
          this.querySelector('.where-to-buy').classList.add('disabled');
          if (requiredBtn) requiredBtn.style.display = 'none';
        }
      });

    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      //- Products combined through custom.linked_products pool every member's media into
      //- a single gallery, so a Wild Weenies PDP carries all seven recipes at once. Narrow
      //- the gallery to the media the selected variant's product carries. Shared media
      //- appears in more than one product's list, so brand images and the video survive
      //- the narrowing on every recipe that carries them.
      var groupDetails = this.mainElement.productData.groupDetails;
      var ownerProductId = groupDetails && groupDetails.groups ? groupDetails.groups[variant.id]?.productId : null;
      var ownerMedia = groupDetails && groupDetails.mediaByProduct ? groupDetails.mediaByProduct[ownerProductId] : null;
      //- Only narrow when that product lists media, so a gap in the mapping leaves the
      //- full gallery rather than an empty one.
      var restrictToOwner = Array.isArray(ownerMedia) && ownerMedia.length > 0;
      var ownerMediaIds = restrictToOwner ? new Set(ownerMedia.map(String)) : null;
      var handled = {};

      this.mainElement.productData.media.forEach((media)=>{
        //- The pooled list repeats media shared between products; decide each one once.
        if(handled[media.id]) {
          return;
        }
        handled[media.id] = true;
        var show = true;
        if(restrictToOwner && !ownerMediaIds.has(String(media.id))) {
          show = false;
        }
        if(show && media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options.findIndex(x=>x==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        //- Media shared between products is rendered once per product that carries it, so
        //- the gallery holds several elements for the same id. Keep one on screen and hide
        //- its copies, otherwise the brand images repeat once per recipe in the group.
        var kept = false;
        this.querySelectorAll('[data-media-id="'+media.id+'"]').forEach((mediaEl)=>{
          mediaEl.style.display = show && !kept ? 'block' : 'none';
          kept = true;
        });
      });

      //- Lay the surviving media out in the selected product's own order. The markup groups
      //- elements by whichever product rendered them, so without this a recipe's own shots
      //- trail behind the shared images instead of sitting among them.
      if(restrictToOwner && this.itemsWrapper) {
        ownerMedia.forEach((mediaId)=>{
          var mediaEl = this.querySelector('[data-media-id="'+mediaId+'"]');
          if(mediaEl && mediaEl.style.display != 'none') {
            this.itemsWrapper.appendChild(mediaEl);
          }
        });
      }

      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          slideChanged: (keen)=>{
            $s.muteAllMedia(this);
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && (this.mobileStyle=='thumbnails' || this.mobileStyle=='carousel_vertical')) || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        var mobileVertical = this.mobileStyle === 'carousel_vertical';
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10,
          centered: false,
          vertical: mobileVertical
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: mobileVertical ? 5.7 : 5,
          spacing: 10,
          centered: false,
          vertical: mobileVertical
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          //- The rail indexes a finite set of images, so wrapping past the last thumb back
          //- to the first gives no sense of where the set ends. Stop at both ends.
          loop: false,
          centered: false,
          slidesPerView: 4.8,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 4.8
          } : {}),
          ...(mobileVertical && $s.media.isSmall ? { vertical: true, slidesPerView: 4.5 } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.percent = this.querySelector('.percent-off');
      this.comparePriceElement = this.querySelector('.compare');
      this.unitPriceElement = this.querySelector('.unit-price');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      // UTM Pricing
      this.enableUtmDiscount = this.dataset.enableUtmDiscount === 'true';

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">Original price: </span>'
        var finalPricePrefix = '<span class="visually-hidden">. Final price: </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
           
            let compareAtPrice = data.compare_at_price;
            let finalPrice = data.compare_at_price > data.price && Array.isArray(data.price_adjustments) && data.price_adjustments.length > 0 ? data.compare_at_price : data.price;
            let utmApplyDiscount = window.UTMDiscount ? window.UTMDiscount.getDiscountApplicable(this.mainElement.dataset.productCollections) : false;
            let utmIsBundleCard = this.mainElement.classList.contains('bundle-card');
            let utmIsProductCard = this.mainElement.classList.contains('product-card') && !utmIsBundleCard;
            let utmDiscountAmount = window.UTMDiscount ? (utmIsProductCard ? window.UTMDiscount.getCardDiscountAmount(this.mainElement.dataset.productCollections) : window.UTMDiscount.getDiscountAmount(this.mainElement.dataset.productCollections)) : 0;

            /* rearrange compare at price - Mike Pucci */
            if (this.enableUtmDiscount && !utmIsBundleCard && utmApplyDiscount && utmDiscountAmount > 0) {
               this.comparePriceElement.classList.remove('hide');

                const originalPrice = finalPrice;
                const basePrice = Array.isArray(data.price_adjustments) && data.price_adjustments.length > 0 ? data.price : originalPrice; // Includes subscription discount
                /* Discount the line total, as the cart does, so rounding matches at any quantity */
                var displayPrice = window.UTMDiscount.applyDiscount(basePrice * quantity, utmDiscountAmount);

                this.comparePriceElement.innerHTML =
                  originalPricePrefix + $s.formatMoney(originalPrice * quantity);

                this.finalPriceElement.innerHTML =
                  finalPricePrefix + $s.formatMoney(displayPrice);
                this.updateUnitPrice(displayPrice, quantity);
              } else {
             /*rearrange compare at price - Mike Pucci */

                /* Fix to always show the original price - SCR-277 */
                if(compareAtPrice > finalPrice) {
                  this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(compareAtPrice * quantity);
                  this.updateUnitPrice(compareAtPrice * quantity, quantity);
                }else{
                  this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(finalPrice * quantity);
                  this.updateUnitPrice(finalPrice * quantity, quantity);
                }
                /* Fix to always show the original price - SCR-277 */
            }
            this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
          } else {
            this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
            this.updateUnitPrice(null);
          }
          if(this.percent != null){
            this.percent.innerHTML = '';
          }

        });
      });
    }

    /* Size option like "14 oz", "21 lb" or "2.7 oz (Pack of 12)" -> {amount, unit} */
    getUnitSize() {
      var variant = this.mainElement.getCurrentVariant();
      if (!variant || !Array.isArray(variant.options)) return null;
      for (var option of variant.options) {
        var match = /(\d+(?:\.\d+)?)\s*(oz|lbs?)\b/i.exec(option || '');
        if (!match) continue;
        var pack = /pack of\s*(\d+)/i.exec(option);
        var amount = parseFloat(match[1]) * (pack ? parseInt(pack[1], 10) : 1);
        if (!(amount > 0)) return null;
        return {amount, unit: match[2].toLowerCase().startsWith('lb') ? 'lb' : 'oz'};
      }
      return null;
    }

    /* Prices are in cents and already multiplied by quantity */
    updateUnitPrice(finalPrice, quantity = 1) {
      if (!this.unitPriceElement) return;
      var size = finalPrice != null ? this.getUnitSize() : null;
      if (!size) {
        this.unitPriceElement.innerHTML = '';
        this.unitPriceElement.classList.add('hide');
        return;
      }
      var perUnit = $s.formatMoney(Math.round(finalPrice / (quantity * size.amount))) + ' / ' + size.unit;
      this.unitPriceElement.innerHTML = '(<span class="visually-hidden">Price per ' + size.unit + ': </span>' + perUnit + ')';
      this.unitPriceElement.classList.remove('hide');
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}))
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var options = ['option1', 'option2', 'option3'];
          var imgOption = options.splice(this.swatchImg.dataset.option/1 -1 ,1);
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value && v[options[0]]==variant[options[0]] && v[options[1]]==variant[options[1]]);
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(v=>v[imgOption]==radio.value);
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_image) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_image.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]);
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content" style="width: ${infoLink.dataset.width}rem">
                <img src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    getOptionValues(currentVariant) {
      var options = [];
      this.mainElement.productData.options.forEach((option, index)=>{
        if(index==0) {
          var optionValues = this.mainElement.productData.variants.map((variant)=>{return {
            value: variant.options[index], 
            available: variant.available
          }});
        }
        if(index==1) {
          var optionValues = this.mainElement.productData.variants.filter(x=>x.options[0]==currentVariant.option1).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        if(index==2) {
          var optionValues = this.mainElement.productData.variants.filter(
            x=>x.options[0]==currentVariant.option1 && x.options[1]==currentVariant.option2
          ).map((variant)=>{return {
            value: variant.options[index],
            available: variant.available
          }});
        }
        //- Products combined through custom.linked_products do not always share the same
        //- option set: a group member with only a Size and no Recipe yields an undefined
        //- value here. Drop those rather than render them, so one mismatched variant
        //- cannot empty the whole selector.
        optionValues = (optionValues || []).filter(x=>x.value != null && x.value !== '');

        var optionValuesUnique = [];
        optionValues.forEach((option, key)=>{
          if(!optionValuesUnique.find(x=>x.value==option.value)) {
            if(option.available) {
              optionValuesUnique.push(option);
            } else {
              if(!optionValues.find((x,y)=>y!=key && x.available && x.value==option.value)) {
                optionValuesUnique.push(option);
              }
            }
          }
        });
        options.push(optionValuesUnique);
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
      var swatchGroupClasses = this.mainElement.matches('product-main') ? 'grid' : 'flex flex-wrap';
  		var html = `
        <div class="option-name small-label">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${optionSelectorLabel(this, this.label)}</span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="swatch-group ${swatchGroupClasses}"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      var swatchItemClasses = this.mainElement.matches('product-main') ? 'grid-item one-third' : '';var wtbOnly = !!this.closest('.wtb-only');
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        
  			html += `
          <div class="swatch ${swatchItemClasses}" data-available="${wtbOnly ? 'true' : 'false'}"${wtbOnly ? '' : ' style="display:none;"'}>
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" />
  				  <label for="${id}">
              <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
              	<span>${option.value}${soldOut}</span>
              </div>
            </label>
          </div>
  			`;
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;


        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      var html = `
        <label class="option-name small-label" for="${optionId}">
        ${this.infoIcon}${optionSelectorLabel(this, this.label)} 
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}"></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';

      this.setAttribute('data-required', 'false');
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



//REF: FEATURE SELLING PLANS
if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.input = this.querySelector('[name="selling_plan"]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textOnetime = this.dataset.textOnetime || "One Time Purchase";
      this.textSubscribe = this.dataset.textSubscribe || "Subscribe";
      this.textSubscribeSave = this.dataset.textSubscribesave || "";
      this.combineGroups = true;
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
      this.mainElement.lastSelectedSellingPlanId = this.input.value || this.mainElement.productData?.sellingPlanGroups?.[0]?.selling_plans?.[0]?.id;

      this.enableUtmDiscount = this.dataset.enableUtmDiscount === 'true';

      this.input.addEventListener('change', ()=>{
        this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
      });

      this.listenEvents = ['variantChange'];
      if (this.multiplyQuantity)
        this.listenEvents.push('quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          this.groupsContainer.innerHTML = this.getGroupsHtml();
          const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(this.input.value);
          const groupId = group ? this.getHandledGroupId(group.id) : '';

          let currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"][value="'+groupId+'"]');

          if (!currentGroupInput) {
            //default to another group or even the One Time purchase if this variant doesn't have Selling Plans available
            currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"]:not([value=""])') || this.groupsContainer.querySelector('[name="purchase_option"]');
          }

          let currentPlanSelect = currentGroupInput.closest('div').querySelector('select');

          const groupInputs = this.groupsContainer.querySelectorAll('[name="purchase_option"]');
          groupInputs.forEach(groupInput=>{
            const planSelect = groupInput.closest('div').querySelector('select');
            groupInput.addEventListener('change', (e)=>{
              this.updateSellingPlan(planSelect ? planSelect.value : '');
            })
            if (planSelect) {
              planSelect.addEventListener('change', (e)=>{
                this.updateSellingPlan(e.target.value);
              });
            }
          })

          currentGroupInput.checked = true;
          if (currentPlanSelect) {
            for (let i = 0; i < currentPlanSelect.options.length; i++) {
              const option = currentPlanSelect.options[i];
              if (option.text == sellingPlan.name || option.value==sellingPlan.id) {
                currentPlanSelect.selectedIndex = i;
              }
            }
          }
          this.updateSellingPlan(currentPlanSelect ? currentPlanSelect.value : '');
          this.showSellingPlanDetails();
        });
      });
      
    }

    getSellingPlanByIdWithGroup(id) {
    
      const root = this.mainElement.productData;
    
      if (!Array.isArray(root?.sellingPlanGroups)) {
        return { sellingPlan: null, group: null };
      }
    
      for (let p = 0; p < root.sellingPlanGroups.length; p++) {
        const product = root.sellingPlanGroups[p];
    
    
        if (!Array.isArray(product.sellingPlanGroups)) continue;
    
        for (let g = 0; g < product.sellingPlanGroups.length; g++) {
          const group = product.sellingPlanGroups[g];
    
    
          if (!Array.isArray(group.selling_plans)) continue;
    
          for (let s = 0; s < group.selling_plans.length; s++) {
            const plan = group.selling_plans[s];
    
    
            if (plan.id == id) {
              return { sellingPlan: plan, group };
            }
          }
        }
      }
    
      return { sellingPlan: null, group: null };
    }
    
    
    

    getHandledGroupId(groupId) {
      return this.combineGroups ? 'subscribe' : groupId;
    }

    showSellingPlanDetails() {
      const currentVariant = this.mainElement.getCurrentVariant();
      const groupLabels = this.groupsContainer.querySelectorAll('[name="purchase_option"]:not([value=""]) + label');
      
      const utmApplyDiscount = window.UTMDiscount ? window.UTMDiscount.getDiscountApplicable(this.mainElement.dataset.productCollections) : false;
      const utmIsBundleCard = this.mainElement.classList.contains('bundle-card');
      const utmIsProductCard = this.mainElement.classList.contains('product-card') && !utmIsBundleCard;
      const utmDiscountAmount = window.UTMDiscount ? (utmIsProductCard ? window.UTMDiscount.getCardDiscountAmount(this.mainElement.dataset.productCollections) : window.UTMDiscount.getDiscountAmount(this.mainElement.dataset.productCollections)) : 0;

      /* MAP policy: no strikethrough pricing on product cards unless the discount is UTM-based */
      const utmDiscountApplied = this.enableUtmDiscount && !utmIsBundleCard && utmApplyDiscount && utmDiscountAmount > 0;
      const isProductCard = this.mainElement.classList.contains('product-card');

      groupLabels.forEach(label=>{
        const planSelect = label.closest('div').querySelector('select');
        const planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==planSelect.value);
        const quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        const discount = planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price ? Math.round(100 - planAlloc.price/planAlloc.compare_at_price*100) : 0;

        let planAllocPrice = planAlloc.price * quantity;
        let planAllocCompareAtPrice = planAlloc.compare_at_price;

        if (utmDiscountApplied) {
          planAllocPrice = window.UTMDiscount.applyDiscount(planAlloc.price * quantity, utmDiscountAmount);
        } else if (isProductCard && planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price) {
          /* MAP policy: cards show the price before the subscription discount */
          planAllocPrice = planAlloc.compare_at_price * quantity;
        }
        const optionPrice = $s.formatMoney(planAllocPrice);

        const optionComparePrice = $s.formatMoney(planAllocCompareAtPrice * quantity);
        const optionCompareHtml = !isProductCard || utmDiscountApplied ? `<span class="option-compare">${optionComparePrice}</span>` : '';
        label.innerHTML = `<div class="subscribe-label"><span class="option-price">${optionPrice}</span>` + (discount ? optionCompareHtml + ' <span class="option-subscribe-save">' + this.textSubscribeSave + '</span>'+ ' <span class="option-discount">'+discount+'%</span>' : '') + `</div>`;

      });
      if(currentVariant.available) {
        this.parentNode.classList.remove('hide');
      } else {
        this.parentNode.classList.add('hide');
      }
      return;
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      if (sellingPlanId) {
        this.mainElement.lastSelectedSellingPlanId = sellingPlanId;
        const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(sellingPlanId);
        this.inputFrequencyName.value = sellingPlan.name;
        this.querySelector(".purchase-option.subscribe-option").classList.add("active");
        if(this.querySelector(".purchase-option.onetime-option") != null){
          this.querySelector(".purchase-option.onetime-option").classList.remove("active");
        }
        this.querySelector(".purchase-option.subscribe-option input.radio-custom").checked = true;
      } else {
        this.inputFrequencyName.value = '';
        if(this.querySelector(".purchase-option.subscribe-option")) this.querySelector(".purchase-option.subscribe-option").classList.remove("active");
        if(this.querySelector(".purchase-option.onetime-option") != null){
          this.querySelector(".purchase-option.onetime-option").classList.add("active");
          this.querySelector(".purchase-option.onetime-option input.radio-custom").checked = true;
        }
      }
      this.showSellingPlanDetails();
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    getGroupsHtml() {
      var showFrequency = true;
      var currentVariant = this.mainElement.getCurrentVariant();
      var html = '';
      var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
    
      // 🛒 One-time purchase
      if (!this.mainElement.productData.requiresSellingPlan) {
        let optionId = `plan-option-onetime-${this.mainElement.sectionId}`;
        let optionPrice = $s.formatMoney(currentVariant.price * quantity);
    
        html += `
          <div class="purchase-option onetime-option">
            <input class="radio-custom" type="radio" name="purchase_option" value="" id="${optionId}">
            <label class="radio-custom-label" for="${optionId}">
              <div>
                <span class="option-price">${optionPrice}</span> ${this.textOnetime}
              </div>
            </label>
          </div>
        `;
      }
    
      if (!currentVariant) return html;
    
      // 🔁 Selling plans
      currentVariant.selling_plan_allocations.forEach((planAlloc, ix) => {
        if (this.combineGroups && ix > 0) return;
    
        let matchedGroup = null;
    
        // 🔍 Find matching selling plan group
        for (let p = 0; p < this.mainElement.productData.sellingPlanGroups.length; p++) {
          const product = this.mainElement.productData.sellingPlanGroups[p];
          if (!Array.isArray(product.sellingPlanGroups)) continue;
    
          for (let g = 0; g < product.sellingPlanGroups.length; g++) {
            const group = product.sellingPlanGroups[g];
            if (group.id == planAlloc.selling_plan_group_id) {
              matchedGroup = group;
              break;
            }
          }
          if (matchedGroup) break;
        }
    
        if (!matchedGroup) return;
    
        const groupId = this.getHandledGroupId(matchedGroup.id);
        let optionId = `plan-option-${groupId}-${this.mainElement.sectionId}`;
    
        html += `
          <div class="purchase-option subscribe-option">
            <input class="radio-custom" type="radio" name="purchase_option" value="${groupId}" id="${optionId}">
            <label class="radio-custom-label" for="${optionId}"></label>
    
            <div data-plans class="${!showFrequency ? 'frequency-hidden' : ''}">
              <div class="promo-text">
                
                <div class="line flex align-items-center">
                  <svg aria-hidden="true" role="presentation" class="icon icon-piggybank" viewBox="0 0 32 32"><path d="M8.8,25.26s3,1.61,3,2.81,0,2.4-1.74,2.4h-4.26c-2.4,0-2.4-2.4-2.4-6s-2.4-4.2-2.4-10.8c0-3.6,2.4-8.4,6.6-8.4h9c3.6-4.8,7.2-3.6,7.2-3.6.6,3-.07,4.75-.07,4.75,2.33,3.55,7.27,4.2,7.27,4.2v9.05c-4.8,0-6.6,4.8-6.6,7.37,0,0,.6,3.43-1.8,3.43h-3.51c-3.51,0-2.49-3.43-2.49-3.43h-5.25M23.2,10.67c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2,1.2-.54,1.2-1.2-.54-1.2-1.2-1.2ZM7,10.07h8.4"></path></svg>
                  <span>Keep saving 5% on every order</span>
                </div>
                
    
                
                <div class="line flex align-items-center">
                  <svg aria-hidden="true" role="presentation" class="icon icon-calendar" viewBox="0 0 32 32"><path d="M26.46,30H5.54c-1.85,0-3.35-1.5-3.35-3.35V7.55c0-1.85,1.5-3.35,3.35-3.35h20.92c1.85,0,3.35,1.5,3.35,3.35v19.11c0,1.85-1.5,3.35-3.35,3.35ZM2.21,11.4h27.6M20.71,20.32l-1.92.63,1.18,1.63v2.02s1.92-.62,1.92-.62l1.92.62v-2.02s1.19-1.63,1.19-1.63l-1.92-.63-1.19-1.63-1.19,1.63ZM8.21,4.2V.6M23.21,4.2V.6"></path></svg>
                  <span>Get deliveries on your schedule</span>
                </div>
                
    
                
                <div class="line flex align-items-center">
                  <svg aria-hidden="true" role="presentation" class="icon icon-edit-paper" viewBox="0 0 32 32"><path d="M25.6,16.33v11.2c0,1.31-1.07,2.38-2.38,2.38H3.98c-1.31,0-2.38-1.07-2.38-2.38V7.09c0-1.31,1.07-2.38,2.38-2.38h13.61M24.05,4.09l4.36,4.36M17.46,19.39l-6.3,1.93,1.93-6.3L25.14,2.99c1.21-1.2,3.16-1.2,4.36,0,1.2,1.2,1.21,3.16,0,4.36l-12.03,12.03ZM13.1,15.03l4.36,4.36M1.6,21.51h7.2"></path></svg>
                  <span>Skip, change, or cancel anytime</span>
                </div>
                
    
                
              </div>
    
              <div>${this.getPlansHtml(matchedGroup)}</div>
            </div>
          </div>
        `;
      });
    
      return html;
    }
    
    

    getPlansHtml(group) {
      //functionalities:
      // show or hide frequency dropdown when the One-Time option is selected
      // show a div with the frequency option when there is a single option but keep the <select> hidden
      //
      var currentVariant = this.mainElement.getCurrentVariant();
      var enabled = this.input.value!='';

      var html = '';
      const groupPlanAllocations = this.combineGroups ? currentVariant.selling_plan_allocations : currentVariant.selling_plan_allocations.filter(x=>x.selling_plan_group_id==group.id);
      var isOneOption = groupPlanAllocations.length==1;
      html = `<div class="field no-label ${isOneOption ? 'hide' : ''}"><select id="frequency-${currentVariant.id}" class="${enabled ? 'enabled' : ''}" {enabled ? '' : 'disabled="disabled"'}>`;
      groupPlanAllocations.forEach((plan)=>{
        const {sellingPlan} = this.getSellingPlanByIdWithGroup(plan.selling_plan_id);
        if (sellingPlan.name.includes('-') || sellingPlan.name.includes('5%')) {
          html += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
        }
      });
      html += `</select><svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path d="M27,10,16,22,5,10"></path></svg></div>`;
      if (isOneOption) {
        html += `<div class="selling-plan-name">${group.selling_plans[0].name}</div>`;
      }

      return html;
    }

    getCurrentPlan() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if(currentVariant) {
        return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
      }
      return false;
    }

  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}
